import FirstLoadController from '../../components/FirstLoadController'

import React from 'react'
import Coops from './Coops'

export default function (props: Props) {
  return (
    <FirstLoadController active={props.active}>
      <Coops {...props} />
    </FirstLoadController>
  )
}
